/* @flow */

import cookies from 'browser-cookies';

import RelayDefaultNetworkLayer from 'react-relay/lib/RelayDefaultNetworkLayer';


export default class ClientNetworkLayer extends RelayDefaultNetworkLayer {
  constructor(uri, init) {
    super(uri, init);
  }

  set _init(init) {
    this.__init = init;
  }

  get _init() {
    const token = cookies.get('token');

    if (!token) {
      return this.__init;
    }

    const { headers, other } = this.__init;

    return {
      ...other,
      headers: {
        Authorization: `Bearer ${token}`,
        ...headers,
      },
    };
  }
}



// WEBPACK FOOTER //
// ../src/client/relay/ClientNetworkLayer.js